<template>
  <div class="overlay" @click.self="closeModal">
    <div v-qa="'app_modal'" class="modal" role="dialog">
      <div class="modal__header">
        <h4 v-qa="'app_modal_header'"><slot name="modal-header"/></h4>
        <button
          v-qa="'app_modal_close_button'"
          type="button"
          class="close-button"
          @click.stop="closeModal">
          <close class="close-icon"/>
        </button>
      </div>

      <div v-qa="'app_modal_body'" class="modal__body">
        <slot name="modal-body"/>
      </div>

      <div v-if="$slots['modal-footer']" v-qa="'app_modal_footer'" class="modal__footer">
        <slot name="modal-footer"/>
      </div>
    </div>
  </div>
</template>

<script>
import close from '~/assets/img/upload/close.svg';

export default {
  name: 'AppModal',
  components: {
    close,
  },
  methods: {
    closeModal() {
      this.$emit('close-modal', false);
    },
  },
};
</script>

<style scoped lang="scss">
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  padding: 24px 8px;
}

.modal {
  background: #fff;
  box-shadow: 2px 2px 20px 1px;
  border-radius: 8px;
  overflow-x: auto;
  overflow-y: scroll;
  max-width: 680px;
  width: 100%;
  max-height: 100%;
  display: grid;
  text-align: center;
  padding: 1rem;

  &__header {
    display: grid;
    grid-column-gap: 10px;
    grid-template-columns: 1fr 24px;
    justify-items: start;
    padding-bottom: 16px;
    font-size: 20px;

    @include mobile {
      grid-template-columns: 1fr auto;
    }

    .close-button {
      border: none;
      background: transparent;
      padding: 0;
      margin: 0;
    }

    .close-icon {
      @include mobile {
        @include square(20px);
      }
    }

    @include mobile {
      padding-bottom: 12px;
      font-size: 18px;
    }
  }

  &__body {
    padding-bottom: 16px;

    @include mobile {
      padding-bottom: 12px;
    }
  }

  &__footer {
    display: flex;
    justify-content: center;
  }
}
</style>
